import { PanToGeoLocation } from "./Controls/PanToGeoLocation";
import { AutoCompleteBox } from "./Controls/AutoCompleteBox";
import { ManualMarker } from "./Controls/ManualMarker";
import { fillReportIncidentForm } from "./Functions";

export class FormMap {
  constructor(googleMaps, mapElement) {
    this.googleMaps = googleMaps;
    // eslint-disable-next-line no-undef
    this.infoWindow = new google.maps.InfoWindow();
    this.startLatitude = 54.8;
    this.startLongitude = 9.6;
    // eslint-disable-next-line no-undef
    this.mapCenter = new google.maps.LatLng(this.startLatitude, this.startLongitude);
    this.mapOptions = {
      zoomControl: true,
      zoomControlOptions: {
        // eslint-disable-next-line no-undef
        position: google.maps.ControlPosition.LEFT_BOTTOM,
      },
      mapTypeControl: true,
      mapTypeControlOptions: {
        // eslint-disable-next-line no-undef
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        // eslint-disable-next-line no-undef
        position: google.maps.ControlPosition.BOTTOM_CENTER,
        mapTypeIds: [
          // eslint-disable-next-line no-undef
          google.maps.MapTypeId.ROADMAP,
          // eslint-disable-next-line no-undef
          google.maps.MapTypeId.HYBRID,
        ],
      },
      scaleControl: true,
      streetViewControl: true,
      rotateControl: false,
      zoom: 8,
      mapId: "6065b1e3a081a13f",
      center: this.mapCenter,
    };

    this.mapHtmlElement = mapElement;

    this.controls = {
      panToGeoLocation: {},
      autoCompleteBox: {},
      manualMarker: {},
    };
  }

  create() {
    // eslint-disable-next-line no-undef
    this.map = new google.maps.Map(this.mapHtmlElement, this.mapOptions);

    // controls
    this.controls.panToGeoLocation = new PanToGeoLocation(this.map, this.infoWindow);
    this.controls.panToGeoLocation.createControl(fillReportIncidentForm, this.mapHtmlElement.dataset.formPrefix);

    this.controls.autoCompleteBox = new AutoCompleteBox(this.map, this.infoWindow);
    this.controls.autoCompleteBox.createControl(fillReportIncidentForm, this.mapHtmlElement.dataset.formPrefix);

    this.controls.manualMarker = new ManualMarker(this.map, this.infoWindow);
    this.controls.manualMarker.createControl(fillReportIncidentForm, this.mapHtmlElement.dataset.formPrefix);
  }
}
